import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AIAgentSuggestions } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { EVENT_DEFINITIONS_QUERY_KEY } from "components/event-definitions/hooks/useEventDefinitions";
import { SUGGESTIONS_QUERY_KEY } from "../api/Suggestions";
const useApplySuggestion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (suggestionId) => AIAgentSuggestions.apply(suggestionId),
    onSuccess: (result) => {
      var _a;
      UserNotification.success("Suggestion applied.", "Tuning advisor");
      queryClient.invalidateQueries({ queryKey: SUGGESTIONS_QUERY_KEY });
      const eventDefinitionId = (_a = result == null ? void 0 : result.event_definition) == null ? void 0 : _a.id;
      if (eventDefinitionId) {
        queryClient.invalidateQueries({ queryKey: [...EVENT_DEFINITIONS_QUERY_KEY, eventDefinitionId] });
      }
    },
    onError: (e) => {
      UserNotification.error(`Apply failed: ${e.message}`, "Tuning advisor");
    }
  });
};
export default useApplySuggestion;
